(async () => {

  if (!customElements.get('product-media')) {

    const { Fancybox } = await import("@fancyapps/ui");
    class RepairForm extends HTMLElement {
      
      constructor() {
        super();

        this.formData = localStorage.getItem('repair-form-data') || {};
        this.loader = this.querySelector('[data-repair-form-loader]');
        this.pagesArr = this.querySelectorAll('[data-form-steps]');
        this.nextStepArr = this.querySelectorAll('[data-next-step]');
        this.prevStepArr = this.querySelectorAll('[data-repair-form-back]');
        this.repairsData = JSON.parse(this.querySelector('[data-repairs-select]').dataset.repairsSelect);
        this.repairsCost = {};
        this.repair = document.getElementById('repair');

        if (typeof this.formData.step === 'undefined') {
          this.formData.step = 1;
        }

        let that = this;

        // catch clicks on next buttons
        this.nextStepArr.forEach(function(nextStep){
          nextStep.addEventListener('click', function(event){
            window.scrollTo({ top: 0, behavior: 'smooth' });
            let step = event.target.dataset.nextStep;
            that.collectData(step);
          });
        });

        // catch clicks on previous buttons
        this.prevStepArr.forEach(function(prevStep){
          prevStep.addEventListener('click', function(event){
            window.scrollTo({ top: 0, behavior: 'smooth' });
            let step = event.target.closest('[data-previous-steps]').dataset.previousStep;
            that.showPage(step);
          });
        });

        let newPageStep = this.formData.step;

        // check if form is posted, then forward to last step
        if (location.search.indexOf('contact_posted=true') > -1) {
          newPageStep = 4;
        }

        this.fancybox();
        this.showPage(newPageStep);
        
      }

      collectData(step) {

        let style = null;
        let flow = null;
        let repairData = null;
        let repairDataArr = null;
        let that = this;
        let repair_type = null;
        let note = null;
        let choice = null;
        let repairPrice = null;
        let discard = null;
        let list = null;

        switch(step) {
          case '2':
            style = document.getElementById('style').value;
            flow = document.getElementById('flow').value;
            that.formData.style = style;
            that.formData.flow = flow;
            repairDataArr = that.repairsData[style].split(',');
            that.customList = document.getElementById('repair-type').querySelector('.custom-select__list');

            // clear data
            list = that.customList.querySelectorAll('li');
            list.forEach(element => {
              element.remove();
            });

            list = that.repair.querySelectorAll('option');
            list.forEach(element => {
              element.remove();
            });

            repairDataArr.forEach(function(repair, index){
              repairData = repair.split('|');

              let option = document.createElement("option");
              option.text = repairData[0];
              option.value = repairData[0];
              that.repairsCost[repairData[0]] = repairData[1];
              that.repair.append(option);

              let listItem = document.createElement("li");
              listItem.innerText = repairData[0];
              listItem.value = repairData[0];
              listItem.dataset.value = repairData[0];
              listItem.dataset.index = index;
              if (index == 0) {
                listItem.classList.add('is-selected');
                document.getElementById('repair-type').querySelector('.custom-select__title').innerText = repairData[0];
              }

              that.customList.append(listItem);
            });
            that.querySelector('[data-previous-step="1"] [data-product-type]').innerHTML = style;
            that.repairField = document.getElementById('repair-type');
            this.showPage(step);
            break;
          case '3':
            that.warranty_type = document.getElementById('flow').value;
            that.divArr = document.querySelectorAll('.repair-form__block');

            if (that.warranty_type == 'warranty') {
              that.divArr[2].classList.add('hidden');
              that.divArr[3].classList.add('hidden');
            } else {
              that.divArr[2].classList.remove('hidden');
              that.divArr[3].classList.remove('hidden');
            }

            discard = document.querySelector('input[name="repair_single_choice"]:checked').value;
            that.formData.discard = discard;
            repair_type = that.repair.value;
            that.formData.repair = repair_type;
            note = document.getElementById('repair_note').value;
            that.formData.note = note;
            choice = document.querySelector('input[name="repair_single_choice"]:checked').value;
            that.formData.choice = choice;
            
            that.querySelector('[data-previous-step="1"] [data-product-types]').innerHTML = that.formData.style;
            that.querySelector('[data-previous-step="2"] [data-product-repair]').innerHTML = that.formData.repair;
            that.querySelector('[data-previous-step="2"] [data-repair-comment]').innerHTML = that.formData.note;

            repairPrice = that.repairsCost[that.formData.repair] / 100;
            that.formData.repairPrice = repairPrice;
            that.querySelector('[data-repair-subcost]').innerHTML = repairPrice;
            that.querySelector('[data-repair-cost]').innerHTML = repairPrice;
            this.showPage(step);
            
            break;
          case '4':
            that.formData.email = document.getElementById('email').value;
            that.formData.phone = document.getElementById('phone').value;
            that.formData.fname = document.getElementById('fname').value;
            that.formData.lname = document.getElementById('lname').value;
            that.formData.street = document.getElementById('street').value;
            that.formData.zip = document.getElementById('zip').value;
            that.formData.city = document.getElementById('city').value;
            that.formData.country = document.getElementById('country').value;
            that.validateForm();

            break;
          default:
            // do nothing
        }

      }

      showPage(pageNumber) {

        // show loader
        this.loader.classList.remove('hidden');
        // hide all pages
        this.pagesArr.forEach(function(page){
          page.classList.add('hidden');
        });

        // give it a bit of timeout for nicer transition
        let that = this;
        setTimeout(function(){
          // show current page
          that.querySelector('[data-form-step="' + pageNumber + '"]').classList.remove('hidden');
          // hide loader
          that.loader.classList.add('hidden');
        }, 500);

      }

      /*
        * Validate form
      */
      validateForm() {

        let validationArr = document.querySelectorAll('[data-repair-form-validate]');
        let valid = true;
        validationArr.forEach(function(validation){
          validation.closest('.repair-form__form-flex').classList.remove('error');
          if (validation.value.length < 1) {
            validation.closest('.repair-form__form-flex').classList.add('error');
            valid = false;
          }
        });

        let validationCheckbox = document.querySelector('[data-repair-form-validate-checkbox]');
        validationCheckbox.closest('.repair-form__terms').classList.remove('error');
        if (!validationCheckbox.checked) {
          validationCheckbox.closest('.repair-form__terms').classList.add('error');
          valid = false;
        }

        if (valid) {
          
          // fill form data
          document.getElementById('form_repair-type').value = this.formData.repair;
          document.getElementById('form_first-name').value = this.formData.fname;
          document.getElementById('form_last-name').value = this.formData.lname;
          document.getElementById('form_email').value = this.formData.email;
          document.getElementById('form_phone').value = this.formData.phone;
          document.getElementById('form_street').value = this.formData.street;
          document.getElementById('form_postcode').value = this.formData.zip;
          document.getElementById('form_city').value = this.formData.city;
          document.getElementById('form_country').value = this.formData.country;
          document.getElementById('form_style').value = this.formData.style;
          document.getElementById('form_warranty').value = this.formData.flow;
          document.getElementById('form_discard').value = this.formData.discard;
          document.getElementById('form_note').value = this.formData.note;
          document.getElementById('form_price').value = this.formData.repairPrice;
  
          // submit form
          document.querySelector('[data-repair-form-form] form').submit();
        }

      }

      /*
        * Create fancybox
      */
      fancybox() {
        // Check if Fancybox exists
        if (typeof Fancybox == 'undefined') {
          return false;
        }
        Fancybox.bind("[data-fancybox]", {
          animated: false,
          showClass: false
        });
      }

    }

    window.RepairForm = RepairForm;

    customElements.define('repair-form', RepairForm);
  }
})();
